// extracted by mini-css-extract-plugin
export var active = "_6y-7";
export var container = "_6y-0";
export var evenWidth = "_6y-4";
export var large = "_6y-5";
export var outlet = "_6y-8";
export var slide = "_6y-2";
export var small = "_6y-6";
export var tab = "_6y-3";
export var tabs = "_6y-1";